// extracted by mini-css-extract-plugin
export default {"main":"Main_main__SqrVH","flareAnimation":"Main_flareAnimation__uzxdk","shine":"Main_shine__5PCPR"};